import { render } from "./IndexTest.vue?vue&type=template&id=46913926"
import script from "./IndexTest.vue?vue&type=script&lang=js"
export * from "./IndexTest.vue?vue&type=script&lang=js"

import "./IndexTest.vue?vue&type=style&index=0&id=46913926&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__